import { Type } from 'class-transformer';
import { WFEBankAccountResultDto } from '../../shared-workflow-module/_models/wfe-bank-account-result-dto';
import { PaymentRequestRawDto } from './payment-request-raw-dto';
import { WFECommunityResultDto } from '../../shared-workflow-module/_models/wfe-community-result-dto';

export class PaymentRequestEditorResultDto {
    @Type(() => PaymentRequestRawDto)
    workflow: PaymentRequestRawDto;

    boardApproval: boolean;
    @Type(() => Date)
    closedBookPeriod: Date;

    @Type(() => WFEBankAccountResultDto)
    bankAccounts: Array<WFEBankAccountResultDto>;

    @Type(() => WFECommunityResultDto)
    targetCommunityList: Array<WFECommunityResultDto>;

    entityUsesSubCategory: boolean;
    payeeHelpKey: string;
}
